import * as types from '../mutation-types'
import * as orderTypes from '../orderModule/mutation-types'
import { storeClient } from '@/service/apiClients'

export default store => {
  store.subscribe(async mutation => {
    switch (mutation.type) {
      case types.SET_AGENT_ID:
      case types.SET_STORE:
        if (store.getters.agentId && store.getters.storeId) {
          const orders = await storeClient.get(`stores/${store.getters.storeId}/orderHistory`)
          store.commit('orderModule/' + orderTypes.SET_ORDER_LIST, orders)
        }
        break
    }
  })
}
